import { render, staticRenderFns } from "./MessageMenu.vue?vue&type=template&id=4064bf20&scoped=true&"
import script from "./MessageMenu.vue?vue&type=script&lang=js&"
export * from "./MessageMenu.vue?vue&type=script&lang=js&"
import style0 from "./MessageMenu.vue?vue&type=style&index=0&id=4064bf20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4064bf20",
  null
  
)

export default component.exports